export const FR_T = {
  HELLO: "Bonjour",
  STARTER: "Tout va commencer ici !",
  LOGIN: "Se connecter",
  YOUR_EMAIL: "Votre mail ou matricule",
  PASSWORD: "Mot de passe",
  FORGOT_PWD: "Mot de passe oublié",
  INVALID_EMAIL: "Adresse mail invalide",
  INVALID_PWD: "Mot de passe invalide",
  TYPE_YOUR_EMAIL:
    "Veuillez saisir votre adresse mail pour réinitialiser votre mot de passe",
  SEND: "Envoyer",
  ROLES: "Rôles",
  NEW: "Nouveau",
  USERS: "Utilisateurs",
  OPERATIONS_MANAGEENT: "Gestion des opérations",
  SALE_OPERATIONS_MANAGEMENT: "Gestion des opérations commerciale",
};
